import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGroupArrowsRotate,
  faUser,
  faBox,
  faMoneyBill,
  faFileInvoice,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import { getTodayDeliveryStats } from "../services/deliveryService"; // API Service
import { getTotalCustomers } from "../services/customerService"; // API Service for fetching total customers
import { getTotalGroupCount } from "../services/customerGroupService";
import Loader from "../components/Loader";

const sections = [
  { name: "Customers", link: "/customer", icon: faUser, key: "customers" },
  {
    name: "Groups",
    link: "/customer-group",
    icon: faGroupArrowsRotate,
    key: "groups",
  },
  {
    name: "Group Management",
    link: "/customer-group-management",
    icon: faGroupArrowsRotate,
  },
  { name: "Products", link: "/product", icon: faBox },
  { name: "Payments", link: "/payment", icon: faMoneyBill },
  { name: "Water Invoices", link: "/invoice", icon: faFileInvoice },
  {
    name: "Loading/Unloading",
    link: "/products/loading-unloading",
    icon: faChartBar,
  },

  // Catering Invoice option add karo yahan:
  {
    name: "Catering Invoices",
    link: "/catering-invoices",
    icon: faFileInvoice,
  },

  //report section
  { name: "Reports", link: "/reports", icon: faChartBar },
];

const Home = () => {
  const [stats, setStats] = useState({
    total_deliveries: 0,
    total_amount_collected: 0,
    total_due_amount: 0,
  });
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState({
    customers: 0,
    groups: 0,
  });

  useEffect(() => {
    fetchTodayStats();
    fetchCounts();
  }, []);

  const fetchCounts = async () => {
    try {
      const customerRes = await getTotalCustomers();
      const groupRes = await getTotalGroupCount();

      setCounts({
        customers: customerRes.success ? customerRes.count : 0,
        groups: groupRes.success ? groupRes.count : 0,
      });
    } catch (error) {
      console.error("Error fetching counts:", error.message);
    }
  };

  const fetchTodayStats = async () => {
    try {
      const response = await getTodayDeliveryStats();
      if (response.success) {
        setStats(response.data);
      } else {
        console.error("Error fetching today's stats");
      }
    } catch (error) {
      console.error("API Error:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4">
      {/* Heading */}
      <h2 className="text-2xl font-bold mb-6 text-center text-blue-600">
        Raj Bhog Caters & Waters
      </h2>

      {/* Today's Stats Section */}
      <div className="bg-gray-100 py-2 px-4 rounded-md shadow-sm mb-4 text-xs font-medium text-gray-700">
        {/* Heading */}
        <p className="text-center text-sm font-semibold text-gray-800 mb-1">
          📊 Today's Total Stats
        </p>

        {loading ? (
          <Loader />
        ) : (
          <div className="flex justify-center gap-x-6">
            <span className="text-blue-600">
              Customers:{" "}
              <span className="font-bold">{stats.total_customers}</span>
            </span>
            <span className="text-blue-600">
              Deliveries:{" "}
              <span className="font-bold">{stats.total_deliveries}</span>
            </span>
            <span className="text-purple-600">
              Sale: <span className="font-bold">₹{stats.total_due_amount}</span>
            </span>
          </div>
        )}
      </div>

      {/* Sections Grid */}
      <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
        {sections.map((section) => (
          <Link
            to={section.link}
            key={section.name}
            className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center hover:bg-gray-100 transition relative"
          >
            <FontAwesomeIcon
              icon={section.icon}
              className="text-blue-600 text-3xl mb-2"
            />
            <p className="text-center text-sm font-semibold">{section.name}</p>

            {/* Badge Style Count */}
            {section.key && counts[section.key] !== undefined && (
              <span className="absolute top-2 right-2 bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm">
                {counts[section.key]}
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Home;
